// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZpsMs","content":"styles_content__ZRz4D","row":"styles_row__ZS95d","footer":"styles_footer__39Uoz"};